<template>

  <div class="container">

    <div class="row">

      <div class="col-12 mt-3">

         <p class="font-weight-lighter text-lg" style="font-weight: 300;">
           Tell me More
           <b-img class="float-right" height="25" src="/assets/logo.png"></b-img>
          </p>

          <p class="font-weight-normal mb-0 pb-0 txt-dark">Am I elegible for ChipIn™?</p>
          <p class="font-weight-light">Yes! All Artists on Trackd are eligible to register and promote ChipIn™ on and off their profile, social media and wherever they choose. </p>
          
          <p class="font-weight-normal mb-0 pb-0 txt-dark">Is it Free to Use ChipIn™?</p>
          <p class="font-weight-light">ChipIn™ requires Artists to upgrade to a Supporter and includes a large number of other membership benefits.</p>
          
          <p class="font-weight-normal mb-0 pb-0 txt-dark">Does Trackd take a cut?</p>
          <p class="font-weight-light">NO! We don’t take a dime of your money that fans donate! Our banking partner however charges a small standard transaction fee to process your payments. </p>
          
          <p class="font-weight-normal mb-0 pb-0 txt-dark">Can my fans Subscribe so I earn every month?</p>
          <p class="font-weight-light">YES! All Chipin donantions have thew option by default of being a monthly subscriber earning you, the Artist a monthly recurring incpome!</p>
          
      </div>

    </div>

  </div>

</template>

<script>

export default {
  name: 'Store',
  data() {
    return  {
      
    }
  }
}
</script>

<style lang="css">

.rounded {
  border-radius: 0.8rem !important;
}

.txt-dark {
  color: #595959 !important;
}
.font-weight-normal {
  font-weight: 500;
}

.text-lg {
  font-size:24px;
}

.text-small {
  font-size: 0.9em;
}

a:hover {
  text-decoration: none;
}

</style>

